import type { CSSProperties, ReactNode } from 'react';
import { Card } from '../../design-system';

/** White surface card with default 24px padding — the recurring dashboard panel. */
export function Panel({
  children,
  style,
  padding = 24,
  onClick,
  className,
  id,
}: {
  children: ReactNode;
  style?: CSSProperties;
  padding?: number;
  onClick?: () => void;
  className?: string;
  /** Scroll target, for a link elsewhere on the page that points at this panel. */
  id?: string;
}) {
  return (
    <Card id={id} className={className} onClick={onClick} style={{ padding, ...style }}>
      {children}
    </Card>
  );
}
